import BossModel from "@/models/BossModel";
import PackageInternalTagType from '@/models/Package/PackageInternalTag/PackageInternalTagType'

export default class PackageInternalTag extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'package/internal-tag';

    /**
     *
     * @type {string}
     */
    static entity = 'packageInternalTags';

    static fields() {
        return {
            id: this.number(null).nullable(),
            name: this.attr(null),
            package_internal_tag_type_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            type: this.belongsTo(PackageInternalTagType, 'package_internal_tag_type_id'),
        }
    }

    /**
     *
     * @param params
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .get().then((data) => {
            let instances = [];
            for (let key in data) {
                instances.push(new PackageInternalTag(data[key]));
            }
            return instances;
        });
    }
}
